// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "q_qR d_gs d_cp";
export var heroHeaderCenter = "q_gt d_gt d_cp d_ds";
export var heroHeaderRight = "q_gv d_gv d_cp d_dt";
export var heroParagraphLeft = "q_qS d_gp d_cs";
export var heroParagraphCenter = "q_gq d_gq d_cs d_ds";
export var heroParagraphRight = "q_gr d_gr d_cs d_dt";
export var heroBtnWrapperLeft = "q_qT d_dZ d_dY d_s d_bw d_bC";
export var heroBtnWrapperCenter = "q_qV d_d0 d_dY d_s d_bw d_bz";
export var heroBtnWrapperRight = "q_qW d_d1 d_dY d_s d_bw d_bD";
export var overlayBtnWrapper = "q_qX d_gn d_X d_4 d_5 d_6 d_bk d_b8";
export var design4 = "q_qY d_gm d_X d_4 d_5 d_bk";
export var heroExceptionSmall = "q_qZ s_qZ";
export var heroExceptionNormal = "q_q0 s_q0";
export var heroExceptionLarge = "q_q1 s_q1";
export var Title1Small = "q_q2 s_q2 s_rk s_rl";
export var Title1Normal = "q_q3 s_q3 s_rk s_rm";
export var Title1Large = "q_q4 s_q4 s_rk s_rn";
export var BodySmall = "q_q5 s_q5 s_rk s_rD";
export var BodyNormal = "q_q6 s_q6 s_rk s_rF";
export var BodyLarge = "q_q7 s_q7 s_rk s_rG";